import { render, staticRenderFns } from "./loading3.vue?vue&type=template&id=356e2e19&scoped=true&"
import script from "./loading3.vue?vue&type=script&lang=js&"
export * from "./loading3.vue?vue&type=script&lang=js&"
import style0 from "./loading3.vue?vue&type=style&index=0&id=356e2e19&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e2e19",
  null
  
)

export default component.exports